export default "__VITE_ASSET__CdjtHxPG__"